module.exports = __webpack_public_path__ + "static/media/credit-card.06df8a1e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/credit-card.svg
 ** module id = 433
 ** module chunks = 0
 **/